import React, { useEffect, useState } from "react";
import Pagination from "../../../utils/Paginate";
import TableLoader from "../../../Skeleton/TableLoader";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ListContentTemplateTypes = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
//   const { token, userMetadata } = useAuth();
	const token = globalConfig.hardcoded_header;
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    contentTemplateTypes: [],
    filteredContentTemplateTypes: [],
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    handleSearch(search);
  }, [search]);
  useEffect(() => {
    console.log(state);
  }, [state]);
  const handleOnLoad = () => {
    setLoading(true);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-template-types `,
        apiHeader(token)
      )
      .then((res) => {
        const contentTemplateTypes = res.data;
        console.log(contentTemplateTypes);
        setState({
          ...state,
          contentTemplateTypes: contentTemplateTypes,
          filteredContentTemplateTypes: contentTemplateTypes,
        });
        setLoading(false);
        console.log(res.data[0]);
      })
      .catch((x) => {
      });
  };
  function onDelete(event) {
    let deleteID = event.target.id;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-template-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({
          ...state,
          contentTemplateTypes: [],
          filteredContentTemplateTypes: [],
        });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({
      ...state,
      contentTemplateTypes: [],
      filteredContentTemplateTypes: [],
    });
    handleOnLoad();
    // this.props.history.push("/list-content-descriptors");
  }

  const handleSearch = (search) => {
    let URL = `${globalConfig.apiDatahubUrl}/content-template-types?filter[limit]=50`;
    URL += `&filter[where][or][0][contentTemplateTypeDescr][regexp]=/(${search})/i`;
    axios.get(URL, apiHeader(token)).then((res) => {
      const contentTemplateTypes = res.data;
      console.log(contentTemplateTypes);
      setState({
        ...state,
        filteredContentTemplateTypes: contentTemplateTypes,
      });
      console.log(res.data[0]);
    })
    .catch((x) => {
    });
  };

  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContentTemplateTypes.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <form>

    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Template Types</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        <Link to="/breeze/create-content-template-type">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
        <Link to="/breeze/list-content-templates">
          <Button
            variant="contained"
            color="warning"
          >
            Templates
          </Button>
        </Link>&nbsp;
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group">
          <input
            className="form-control"
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            id="exampleFormControlInput1"
            placeholder="Search"
          />
        </div>
        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Description</th>
                <th scope="col">Code</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                currentData.map(
                  ({
                    contentTemplateTypeId,
                    contentTemplateTypeDescr,
                    contentTemplateTypeValueCode,
                  }) => {
                    return (
                      <tr>
                        <td><Link
                            to={{
                              pathname: "/manage-content-template-types",
                              search: `?id=${contentTemplateTypeId}`,
                            }}
                          >{contentTemplateTypeId}</Link></td>
                        <td><Link
                            to={{
                              pathname: "/manage-content-template-types",
                              search: `?id=${contentTemplateTypeId}`,
                            }}
                          > {contentTemplateTypeDescr}</Link></td>
                        <td> <Link
                            to={{
                              pathname: "/manage-content-template-types",
                              search: `?id=${contentTemplateTypeId}`,
                            }}
                          >{contentTemplateTypeValueCode}</Link></td>
                        <td>
                          <Link
                            className="btn btn-success"
                            to={{
                              pathname: "/manage-content-template-types",
                              search: `?id=${contentTemplateTypeId}`,
                            }}
                          >
                            Edit{" "}
                          </Link>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentTemplateTypeId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(4).fill(0).map((_, index) => (
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          dataPerPage={globalConfig.dataPerPage}
          totaldata={state.filteredContentTemplateTypes.length}
          paginate={paginate}
          currentPage={currentPage}
          onChange={handlePage}
        />
      </div>
    </form>
  );
};

export default ListContentTemplateTypes;
